'use strict';

module.exports = /* @ngInject */ function ($resource, apiConfig) {

	return {
		error: function(msg) {
			growl(msg.data.error, 1);
		},
		inventory: $resource(
					apiConfig.$get().apiUrl + '/warehouse/inventory/:inventory_id',
					{
						supplier_company_id:'@supplier_company_id',
						sku:'@sku'
					}
				),
		hasArticleQuantity: $resource(
			apiConfig.$get().apiUrl + '/warehouse/inventory/article',
			{
				supplier_company_id:'@supplier_company_id', 
				sku:'@sku'
			}, {
				query: {
					isArray: false,
				}
			}
		),
		getArticleQuantity: $resource(
			apiConfig.$get().apiUrl + '/warehouse/inventory/article/quantity',
			{
				supplier_company_id:'@supplier_company_id', 
				sku:'@sku'
			}, {
				query: {
					isArray: false,
				}
			}
		),
		getInventorySum: function(inventories) {
			var ret = 0;
			angular.forEach(inventories, function(item, key) {
				ret = ret + item.quantity;
			});
			return ret;
		},
		getAvailabilityClass: function(requested, available) {
			var ret;
			
			if(requested > available) {
				ret = 'danger';
			}
			else if(requested === available) {
				ret = 'warning';
			}
			else {
				ret = 'success';
			}

			return ret;
		}
	};
}
